import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalRedemption from '../modals/ModalRedemption';

const Level = ({
  level: l,
  scored = 0,
  progress = false,
  current = {},
  redemption = false,
  redeemed = false,
  ...props
}) => {
  const { i18n } = useTranslation();
  const isCurrent = current._id === l._id;
  const icon = l[isCurrent ? 'activeIcon' : 'icon']?.[0]?.path;

  return (
    <div {...props}>
      <div className="pb-4">
        <img
          src={`/uploads/${icon}`}
          alt=""
          style={{ width: '150px' }}
          // className={current._id === l._id ? 'tranform-scaleUp' : ''}
        />
      </div>
      <h4 className="fw-bold">{i18n.pickLng(l.title)}</h4>
      {l.score > 0 && (
        <>
          <h4 className="fw-bold">
            {Math.min(scored, l.score)}
            /
            {l.score}
          </h4>
          {progress && (
            <div className="px-3">
              <div className="progress" style={{ height: '.7rem' }}>
                <div
                  className="progress-bar"
                  style={{
                    width: `${Math.round((scored / l.score) * 100)}%`,
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}
      {redemption && !!l.score && scored > l.score && (
        <div className="mt-3">
          <ModalRedemption level={l} redeemed={redeemed} />
        </div>
      )}
    </div>
  );
};

export default Level;
